import useSWR from 'swr';

import { useAuthContext } from 'src/auth/hooks';
import { isSuperAdmin } from 'src/auth/impersonation';
import { isStudentUser } from 'src/auth/student-microsoft-login';
import { API_ENDPOINTS, fetcher } from 'src/utils/axios';

// ----------------------------------------------------------------------

/**
 * Dev-only "view as student" (#605): true only for a super admin, signed in as
 * themselves, on a server that has it enabled. The config endpoint does not
 * exist (404) anywhere it is off, so any error means no.
 */
export function useCanViewAsStudent() {
  const { user, impersonatedBy } = useAuthContext();
  const eligible = isSuperAdmin(user) && !isStudentUser(user) && !impersonatedBy;

  const { data } = useSWR(eligible ? API_ENDPOINTS.studentImpersonation.config : null, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateIfStale: false,
  });

  return eligible && data?.enabled === true;
}
